import { DISCOUNTS, LocationVarKey } from "@swivl-mono/types";

import { SearchableLabel } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { TOPIC_VARS_BY_ID } from "../../../Views/Properties/CortexV3/Topics";
import { CortexTopicWorksheet } from "../Components/CortexTopicWorksheet";

export const PAGE_KEYS: LocationVarKey[] = TOPIC_VARS_BY_ID["discounts"] ?? [];

export const SEARCH_LABELS: SearchableLabel[] = DISCOUNTS.map((d) => ({ title: d.label, snippet: d.description }));

export default function DiscountsPage(): React.ReactElement {
  return (
    <CortexTopicWorksheet
      topicId="discounts"
      heading="Discounts"
      description="Tell the bot which discounts your facility offers and how each one works."
      sectionEditing
    />
  );
}
